import React from 'react';
import cn from 'classnames';
import find from 'lodash/find';
import { useOptions } from 'helper/hooks';
import { TRAILER_LENGTH_FIELD } from 'helper/const';
import ClassTooltipContent from 'views/pages/ClientDetail/CompanyOfficial/components/ClassTooltipContent';
import {
  Section as ElementSection,
  FormSection,
  ListInfo,
  InputSearchButton,
  ShouldUpdateWrapper,
} from 'views/pages/ClientDetail/components/Elements';
import InputItem from 'views/pages/ClientDetail/components/InputItem';
import { PROFILE_OBJ_KEYS, AXLES_OPTIONS } from '../../constants';
import classes from './Section.module.scss';

const Profile = ({
  className,
  isEdit,
  form,
  data,
  showManualVin,
  onSearchVIN,
  vinDecoderLoading,
  vinRef,
  searchedVinSuccess,
  isEId,
  searchFields,
}) => {
  const isValidVin = !!data.valid_vin;
  const { stateOptions, scTrailerTypeOptions } = useOptions();

  return (
    <div className={cn(classes.profileSection, className)}>
      <ElementSection className={classes.elSection}>
        {isEdit ? (
          <FormSection>
            {/* Use it to save delete_attachments for attachment removing */}
            <InputItem name={'delete_attachments'} label="" form={form} hide />
            <InputItem name={'valid_vin'} label="" form={form} hide />
            <div className={classes.vinWrapper}>
              <InputItem
                name={'vin'}
                label="VIN - Vehicle Identification Number"
                form={form}
                required
                fullWidth
                inputRef={vinRef}
                disabled={isEId}
              />
              {!isEId && (
                <InputSearchButton
                  onClick={onSearchVIN}
                  loading={vinDecoderLoading}
                  form={form}
                />
              )}
            </div>
            {showManualVin && (
              <>
                <InputItem
                  name={'trailer_unit'}
                  label="Trailer Unit #"
                  form={form}
                  required
                  addressGroupField
                />
                <InputItem
                  name={'trailer_type_id'}
                  label="Type of Trailer"
                  form={form}
                  type="select"
                  options={scTrailerTypeOptions}
                  required
                  addressGroupField
                />
                <ShouldUpdateWrapper>
                  {() => {
                    const values = form.getFieldsValue();
                    const foundOption =
                      find(scTrailerTypeOptions, {
                        value: values.trailer_type_id,
                      }) || {};
                    if (foundOption.label !== 'Other') {
                      return <></>;
                    }
                    return (
                      <>
                        <InputItem
                          name={'trailer_type_other'}
                          label="Other"
                          form={form}
                        />
                      </>
                    );
                  }}
                </ShouldUpdateWrapper>
                <InputItem
                  name={'color'}
                  label="Color"
                  form={form}
                  addressGroupField
                />
                <InputItem
                  name={'year'}
                  label="Year"
                  form={form}
                  addressGroupField
                  disabled={
                    (searchedVinSuccess && searchFields.year) || isValidVin
                  }
                  required
                />
                <InputItem
                  name={'make'}
                  label="Make"
                  form={form}
                  disabled={
                    (searchedVinSuccess && searchFields.make) || isValidVin
                  }
                  addressGroupField
                  required
                />
                <InputItem
                  name={'model'}
                  label="Model"
                  form={form}
                  required
                  disabled={
                    (searchedVinSuccess && searchFields.model) || isValidVin
                  }
                  addressGroupField
                />
                <InputItem
                  name={'axles'}
                  label="Axles"
                  form={form}
                  addressGroupField
                  type="select"
                  options={AXLES_OPTIONS}
                  disabled={
                    (searchedVinSuccess && searchFields.axles) || isValidVin
                  }
                  // disabled={searchedVinSuccess}
                  required
                />
                <InputItem
                  name={'unladen_weight'}
                  label="Unladen Weight (lbs.)"
                  placeholder="0,000,000"
                  form={form}
                  addressGroupField
                  disabled={
                    (searchedVinSuccess && searchFields.unladen_weight) ||
                    isValidVin
                  }
                  labelTooltip={
                    <ClassTooltipContent
                      title="Unladen Weight"
                      description={<>Weight of empty trailer.</>}
                    />
                  }
                  required
                />
                <InputItem
                  name={'gvwr'}
                  label="GVWR (lbs.)"
                  form={form}
                  placeholder="0,000,000"
                  addressGroupField
                  disabled={
                    (searchedVinSuccess && searchFields.gvwr) || isValidVin
                  }
                  labelTooltip={
                    <ClassTooltipContent
                      title={
                        <>
                          Gross Vehicle Weight Rating
                          <br />
                          or Registered Weight
                        </>
                      }
                      description={
                        <>Weight of truck and trailer fully loaded.</>
                      }
                    />
                  }
                  required
                />
                <InputItem
                  name={'trailer_length'}
                  label="Trailer Length (ft/in)"
                  form={form}
                  addressGroupField
                  type="number"
                  placeholder={TRAILER_LENGTH_FIELD.PLACEHOLDER}
                  mask={TRAILER_LENGTH_FIELD.MASK}
                />
                <InputItem
                  name={'lp_number'}
                  label="License Plate #"
                  placeholder="Plate number"
                  form={form}
                  addressGroupField
                />
                <InputItem
                  name={'lp_state_id'}
                  label="License Plate State"
                  form={form}
                  addressGroupField
                  type="select"
                  options={stateOptions}
                />
                <InputItem
                  name={'lp_exp_date'}
                  label="Plate Exp. Date"
                  form={form}
                  type="date"
                />
              </>
            )}
          </FormSection>
        ) : (
          <ListInfo objKeys={PROFILE_OBJ_KEYS} data={data} />
        )}
      </ElementSection>
    </div>
  );
};

export default Profile;
